import type { EntityId } from '@reduxjs/toolkit';

import type { UserEntity } from '../interfaces/users.interface';

const userItems: UserEntity[] = [];

const entities: Record<string, UserEntity> = {};

userItems.forEach(item => (entities[item.id] = { ...item }));

const ids = Object.keys(entities) as EntityId[];

export const selected: EntityId[] = [];

export const usersData = { ids, entities, selected };
